import React from 'react';

function LogoBook() {
  return (
    <svg
      className="LogoBookSvg mg-2"
      width="410"
      height="437"
      viewBox="0 0 410 437"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M205 231L12 128V323L205 425.5M205 231L398.5 129V322L205 425.5M205 231V425.5M56.5 307V203M99.5 234L163.5 266M96.5 282.5L150.5 310M249 264.5L355.5 205.5M252.5 311.5L283 295"
        stroke="#952135"
        strokeWidth="23"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M328.396 278.604C328.396 286.636 322.151 293.104 314.5 293.104C306.849 293.104 300.604 286.636 300.604 278.604C300.604 270.573 306.849 264.104 314.5 264.104C322.151 264.104 328.396 270.573 328.396 278.604Z"
        fill="#952135"
        stroke="#2B2B2B"
        strokeWidth="1.20833"
      />
      <path
        d="M112.396 330.604C112.396 338.636 106.151 345.104 98.5 345.104C90.8486 345.104 84.6042 338.636 84.6042 330.604C84.6042 322.573 90.8486 316.104 98.5 316.104C106.151 316.104 112.396 322.573 112.396 330.604Z"
        fill="#952135"
        stroke="#2B2B2B"
        strokeWidth="1.20833"
      />
      <path
        d="M368.396 252.604C368.396 260.636 362.151 267.104 354.5 267.104C346.849 267.104 340.604 260.636 340.604 252.604C340.604 244.573 346.849 238.104 354.5 238.104C362.151 238.104 368.396 244.573 368.396 252.604Z"
        fill="#952135"
        stroke="#2B2B2B"
        strokeWidth="1.20833"
      />
      <path
        d="M367.396 301.604C367.396 309.636 361.151 316.104 353.5 316.104C345.849 316.104 339.604 309.636 339.604 301.604C339.604 293.573 345.849 287.104 353.5 287.104C361.151 287.104 367.396 293.573 367.396 301.604Z"
        fill="#952135"
        stroke="#2B2B2B"
        strokeWidth="1.20833"
      />
      <path
        d="M206 194.432C156.23 172.082 103.5 149.001 85 123C66.5 96.9993 59 87.5 47 48C72.1887 50.4116 83.977 52.4101 107 56.5007M206 194.432C181.138 139.134 170.678 106.441 107 56.5007M206 194.432C251.372 175.086 273.174 160.679 309.5 137.432C342.5 100 363 77.9993 363 48.4993C315.7 47.544 288.5 59.5 257 96C237 123.5 228.5 147 206 194.432ZM107 56.5007L109.5 11.5C161.504 35.3853 183.772 55.5061 206 108.5C225.195 51.3011 260.5 30 301.5 10C301.5 20.5 301.5 14.3982 301.5 59.3982"
        stroke="#220000"
        strokeWidth="20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LogoBook;
